import { useEffect, useState } from 'react';

import { handleSearch, searchFieldExtractors } from '../../../utils/search';
import useSortableData from '../../../hooks/useSortableData';
import { useProviderDetailsState } from './useProviderDetailsState';

import type { IPayorProviderCredential } from '../../../../utils/types';

export function usePayorCredentialsList() {
  const { payorProviderCreds, credsLoading } = useProviderDetailsState();
  const [payorCredentials, setPayorCredentials] = useState<IPayorProviderCredential[]>([]);
  const [editableCredentialIndex, setEditableCredentialIndex] = useState<number | null>(null);
  const [isNewCredentialAdding, setIsNewCredentialAdding] = useState(false);
  const [credentialSearchStr, setCredentialSearchStr] = useState('');

  const {
    data: sortedPayorCredentials,
    handleSorting: sortPayorCredentials,
    sortField: payorCredentialsSortField,
    sortOrder: payorCredentialsSortOrder,
  } = useSortableData(payorCredentials, 'date_start', 'desc');

  useEffect(() => {
    setPayorCredentials(payorProviderCreds);
  }, [payorProviderCreds]);

  const handleCredentialSearch = (searchStr: string) => {
    handleSearch(
      searchStr,
      payorProviderCreds,
      (credential) => [credential?.payor?.label, ...searchFieldExtractors.dateFields(credential)],
      setCredentialSearchStr,
      setPayorCredentials,
    );
  };

  return {
    payorCredentials,
    setPayorCredentials,
    sortedPayorCredentials,
    credsLoading,
    credentialSearchStr,
    payorCredentialsSortField,
    payorCredentialsSortOrder,
    isNewCredentialAdding,
    setIsNewCredentialAdding,
    editableCredentialIndex,
    setEditableCredentialIndex,
    handleCredentialSearch,
    sortPayorCredentials,
  };
}
